import React, { useState, useContext } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import { useForm } from "../../../../../hooks/useForm";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router";
import { AppContext } from "../../../Context/Context";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    button: {
        marginRight: theme.spacing(1)
    },
    disabledButton: {
        marginRight: theme.spacing(1),
        background: "rgb(155, 20, 48) !important",
        color: "white !important"
    },
    instructions: {
        marginTop: "1rem",
        marginBottom: "1rem"
    }
}));

export const ArrepentimientoModal = ({ handleClose, children }) => {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const steps = getSteps();
    const [count, setCount] = useState(60);
    const [intervalId, setIntervalId] = useState(0);
    const [sentTo, setSent] = useState("");

    //estílos de los elementos del stepper
    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = "#EFAD33";
            return {
                ...styles,
                backgroundColor: isDisabled
                    ? "#EFAD33"
                    : isSelected
                    ? data.color
                    : isFocused
                    ? color
                    : null,
                color: isDisabled
                    ? "#ccc"
                    : isSelected
                    ? "#D1D1D1"
                    : data.color,
                cursor: isDisabled ? "not-allowed" : "default",

                ":active": {
                    ...styles[":active"],
                    backgroundColor:
                        !isDisabled && (isSelected ? data.color : color)
                }
            };
        }
    };

    // useForm Hook procesa el input change y setea los valores.
    const [formValues, handleInputChange, reset] = useForm({
        CUIT: "",
        controlCode: ""
    });
    //Las reglas de verificación de los campos
    const handleVerify = (field, fieldData) => {
        //const regex = /^[0-9]*$/;
        //const onlyNumbers = regex.test(dni);
        //console.log(field);
        if (
            field === "CUIT" &&
            (fieldData < 2010000000 || fieldData > 35000000000)
        ) {
            return false;
        }
        if (field === "controlCode" && fieldData <= 0) {
            return false;
        }
        return true;
    };
    const [state, setState] = useContext(AppContext);

    //si hay error requestOK = false
    const [requestOK, setRequestOK] = useState(true); //requestOK es un chequeo si existe un error en la solicitud a la API. si hay error pasar a false
    //verifyFieldError es un check para los inputs mal ingresados
    const [verifyFieldError, setVerifyFieldError] = useState(false);
    //message representa la devolución por parte del Backend
    const [message, setMessage] = useState("");
    //Texto de los steps
    function getSteps() {
        return ["Ingreso de CUIT", "Código de control"];
    }

    //Contenido dentro del modal
    function getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <>
                        <p>Por favor ingrese su CUIT</p>
                        <input
                            type="number"
                            placeholder="CUIT"
                            name="CUIT"
                            autoComplete="off"
                            value={formValues.CUIT}
                            onChange={handleInputChange}
                            className="modal-input rect"
                            id="cuit-focus"
                            onFocus={() => setVerifyFieldError(false)}
                        />
                        <small style={{ color: "red" }}>
                            {verifyFieldError &&
                                "El CUIT ingresado no es válido"}
                        </small>
                        {!requestOK && <div>{message}</div>}
                    </>
                );
            case 1:
                return (
                    <>
                        <div>{message}</div>
                        <input
                            className="w-100 modal-input"
                            type="number"
                            placeholder="Código"
                            name="controlCode"
                            autoComplete="off"
                            value={formValues.controlCode}
                            onChange={handleInputChange}
                            onFocus={() => setVerifyFieldError(false)}
                        />
                        <div className="w-100">
                            <small style={{ color: "red" }}>
                                {verifyFieldError &&
                                    "Debe completar este campo."}
                            </small>
                        </div>
                    </>
                );
            default:
                return "Gracias, su solicitud a sido registrada correctamente. Aguarde un momento por favor.";
        }
    }

    //Acciones de los botones
    const handleNext = async (sendTo = "") => {
        setVerifyFieldError(false);
        if (
            !handleVerify(
                activeStep === 0 ? "CUIT" : "controlCode",
                activeStep === 0 ? formValues.CUIT : formValues.controlCode
            )
        ) {
            setVerifyFieldError(true);
            return;
        }
        //Solicitud a la API para comprobar el CUIT
        if (activeStep === 0) {
            try {
                const endpoint = await (await fetch('/api/show_endpoints/wsenviarcodigo')).json();
                let response = await fetch(
                    `${endpoint.url_base}${endpoint.url_variable}?CUIT=${
                        formValues.CUIT
                    }&TipoEnvio=${sendTo === "SMS" ? "S" : "M"}`
                , {method: endpoint.metodo, cache: 'no-cache'});
                response = await response.json();
                console.log(response);
                setMessage(response.ErrorDescripcion);
                if (response.ErrorCodigo === "00") {
                    setRequestOK(true);
                    setCount(60);
                    let internalCount = count;
                    const newIntervalId = setInterval(() => {
                        setCount(prevState => prevState - 1);
                        internalCount--;
                        if (internalCount === 0) clearInterval(newIntervalId);
                    }, 1000);
                    setIntervalId(newIntervalId);
                    setSent(sendTo);
                    setActiveStep(prevActiveStep => prevActiveStep + 1);
                } else {
                    setRequestOK(false);
                }
            } catch (err) {
                console.log("Error: ", err);
            }
        }
        //Solicitud a la API para comprobar el código de control
        if (activeStep === 1) {
            try {
                const endpoint = await (await fetch('/api/show_endpoints/WSValidarCodigo')).json();
                let response = await fetch(
                    `${endpoint.url_base}${endpoint.url_variable}?CUIT=${formValues.CUIT}&Codigo=${formValues.controlCode}&TokenLogin=ARREPENTIMIENTO`,
                    {
                        cache: 'no-cache'
                    }
                );
                response = await response.json();
                console.log(response);
                if (response.ErrorCodigo === "00") {
                    //Nos vamos para la nueva página
                    sessionStorage.setItem(
                        "dttk",
                        btoa(response.TokenLogin)
                    );
                    clearInterval(intervalId);
                    onClose(formValues.CUIT);
                } else {
                    setMessage(response.ErrorDescripcion);
                    setRequestOK(false);
                }
            } catch (err) {
                console.log("Error: ", err);
            }
        }
    };

    const handleResend = async (sendTo = "") => {
        try {
            const endpoint = await (await fetch('/api/show_endpoints/wsenviarcodigo')).json();
            let response = await fetch(
                `${endpoint.url_base}${endpoint.url_variable}?CUIT=${
                    formValues.CUIT
                }&TipoEnvio=${sendTo === "SMS" ? "S" : "M"}`,
                {
                    cache: "no-cache",
                }
            );
            response = await response.json();
            console.log(response);
            setMessage(response.ErrorDescripcion);
            if (response.ErrorCodigo === "00") {
                setRequestOK(true);
                setCount(300);
                let internalCount = count;
                const newIntervalId = setInterval(() => {
                    setCount(prevState => prevState - 1);
                    internalCount--;
                    if (internalCount === 0) clearInterval(newIntervalId);
                }, 1000);
                setIntervalId(newIntervalId);
            } else {
                setRequestOK(false);
            }
        } catch (err) {
            console.log("Error: ", err);
        }
    };

    const history = useHistory();
    const onClose = CUIT => {
        //Cargo en el context
        setState(prevState => {
            return { ...prevState, arrepentimientoCUIT: CUIT };
        });
        history.push(`/seleccion_arrepentimiento_plan/${CUIT}`);
        handleClose();
    };
    const onCloseX = () => {
        if (intervalId) {
            clearInterval(intervalId);
        }
        setActiveStep(0);
        reset();
        setMessage("");
        handleClose();
    };

    return (
        <>
            <div className="form-modalBackdrop"></div>
            <div className="form-modalScreenContainer">
                <div className="form-modalScreen justify-content-start">
                    <div className="closeButton ">
                        <span onClick={onCloseX}>X</span>
                    </div>
                    <div className="title">
                        <Stepper activeStep={activeStep}>
                            {steps.map((label, index) => {
                                const stepProps = {};
                                const labelProps = {};
                                return (
                                    <Step key={label} {...stepProps}>
                                        <StepLabel {...labelProps}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                );
                            })}
                        </Stepper>
                    </div>
                    <div className="w-50 h-100 d-flex justify-content-center align-items-center">
                        {activeStep === steps.length ? (
                            <div
                                className="h-100 d-flex justify-content-center align-items-center"
                                style={{ width: "80%" }}
                            >
                                <Typography className={classes.instructions}>
                                    Gracias, su solicitud a sido registrada
                                    correctamente. Aguarde un momento por favor.
                                </Typography>
                                <div className="d-flex justify-content-center align-items-center">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => onClose(formValues.CUIT)}
                                        className={classes.button}
                                        style={{ background: "#FF1430" }}
                                    >
                                        Finalizar
                                    </Button>
                                </div>
                            </div>
                        ) : (
                            <div className="w-100    h-100 d-flex justify-content-around flex-column">
                                <Typography
                                    className={
                                        classes.instructions + " content"
                                    }
                                >
                                    {getStepContent(activeStep)}
                                </Typography>
                                <div className="d-flex justify-content-end align-items-center">
                                    {activeStep === 0 && (
                                        <>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() =>
                                                    handleNext("SMS")
                                                }
                                                className={classes.button}
                                                style={{
                                                    background: "#FF1430"
                                                }}
                                            >
                                                Enviar código por SMS
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() =>
                                                    handleNext("MAIL")
                                                }
                                                className={classes.button}
                                                style={{
                                                    background: "#FF1430"
                                                }}
                                            >
                                                Enviar código por Mail
                                            </Button>
                                        </>
                                    )}
                                    {activeStep === 1 && (
                                        <>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() =>
                                                    handleResend(sentTo)
                                                }
                                                className={
                                                    count > 0
                                                        ? classes.disabledButton
                                                        : classes.button
                                                }
                                                disabled={count > 0}
                                            >
                                                {count > 0
                                                    ? `Aguarde ${count}s para reenviar`
                                                    : `Reenviar código por ${sentTo}`}
                                            </Button>
                                        </>
                                    )}
                                    {activeStep !== 0 && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleNext}
                                            className={classes.button}
                                            style={{ background: "#FF1430" }}
                                        >
                                            Siguiente
                                        </Button>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
